import { useMutation } from '@tanstack/vue-query'
import type { ChangeContractInput } from '~/resources/graphql/graphql'
import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useSelectedLanguage } from '~/composables/use-selected-language'

export function useAgreementChangeContractMutation() {
    const query = useRpQuery()
    const selectedLanguage = useSelectedLanguage()
    const activeFacility = useActiveFacility()

    return useMutation({
        mutationFn: (mutationData: ChangeContractInput) =>
            query(
                graphql(/** @lang GraphQL */ `
                    mutation AgreementChangeContractMutation(
                        $input: ChangeContractInput!
                        $facilityId: ID!
                        $language: Language!
                    ) {
                        changeContract(input: $input) {
                            __typename
                            ... on ChangeContractResult {
                                recordId
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseAgreementContractFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id,
                    language: selectedLanguage.value
                }
            )
    })
}
